import { render, staticRenderFns } from "./MyCommentSkeleton.vue?vue&type=template&id=922144f8"
import script from "./MyCommentSkeleton.vue?vue&type=script&lang=js"
export * from "./MyCommentSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports